// extracted by mini-css-extract-plugin
export default {"Confirmation":"ModalAboutUs_Confirmation__IN-fQ","box":"ModalAboutUs_box__Nqw54"};